import { useContext } from "react";
import {
  ConsolidatedPriceResponse,
  OrderPriceRequest,
  PricingPayload,
  PricingWithTaxDetails,
  PricingWithTaxDetailsRequest,
} from "./pricingInterfaces";
import { ApiContext } from "../../context/ApiContext/ApiContext";
import { ConfigContext } from "../../context/ConfigContext";
import { PricingDetailsResponse } from "../../pages/parts/PartInfo/types";

const usePricingApi = () => {
  const axios = useContext(ApiContext);
  const { PRICING_SERVICE_URL: baseUrl } = useContext(ConfigContext);
  return {
    getPricing: async (
      accountId: string,
      partNumber: string
    ): Promise<PricingDetailsResponse> => {
      const response = await axios.getWithRetries(
        `${baseUrl}/pricing/v1/search`,
        {
          params: {
            accountId,
            partNumber,
          },
        }
      );
      return response.data;
    },
    getPricings: async (
      payload: PricingPayload
    ): Promise<PricingDetailsResponse[]> => {
      const response = await axios.postWithRetries(
        `${baseUrl}/pricing/v1/search`,
        payload
      );
      return response.data;
    },
    getLinePriceDetails: async (
      pricingRequest: PricingWithTaxDetailsRequest
    ): Promise<PricingWithTaxDetails> => {
      const response = await axios.postWithRetries(
        `${baseUrl}/pricing/v1/line-price`,
        pricingRequest
      );
      return response.data;
    },
    getConsolidatedPriceDetails: async (
      consolidatedPriceRequest: PricingWithTaxDetailsRequest[]
    ): Promise<ConsolidatedPriceResponse> => {
      const response = await axios.postWithRetries(
        `${baseUrl}/pricing/v1/consolidated-items-prices`,
        consolidatedPriceRequest
      );
      return response.data;
    },

    getOrderPriceDetails: async (
      orderPriceRequests: OrderPriceRequest
    ): Promise<ConsolidatedPriceResponse> => {
      const response = await axios.postWithRetries(
        `${baseUrl}/pricing/v1/order-header-prices`,
        orderPriceRequests
      );
      return response.data;
    },
  };
};
export default usePricingApi;
